import React from 'react';
import { Link } from 'react-router-dom';

function FeaturesFour() {
  return (
    <section className="features-four">
      <div className="container">
        <div className="features-four-title-box">
          <div
            className="section-four-title wow fadeInUp animated"
            data-wow-duration="1500ms"
            data-wow-delay="100ms"
          >
            <div className="section-four-title-title text-center">
              <h2>
                Planning Making Easy to Turn Dreams your website{" "}
                <span className="section-four-title-title-inner">
                  SEO
                </span>{" "}
                Camping
              </h2>
            </div>
          </div>
          <div
            className="section-four-details text-center wow fadeInUp animated"
            data-wow-duration="1500ms"
            data-wow-delay="300ms"
          >
            <p>
              Digital marketing &amp; advertising approach focuses on
              capturing the essential
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
            <div
              className="features-four-box features-four-box-1 wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="700ms"
            >
              <div className="features-four-icon-one">
                <i className="icon-Line" />
              </div>
              <div className="features-four-title-box">
                <h3>Paid Media Strategy</h3>
              </div>
              <div className="features-four-icon-two">
                <i className="icon-seo21" />
              </div>
              <div className="features-four-detail-box">
                <p>Sed persiciat undoe mnis natus voluptat accus</p>
              </div>
              <div className="features-four-btn">
                <Link to="/services-details">Read More</Link>
                <i className="icon-right-arrow" />
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
            <div
              className="features-four-box features-four-box-2 wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="500ms"
            >
              <div className="features-four-icon-one">
                <i className="icon-Line" />
              </div>
              <div className="features-four-title-box">
                <h3>Website Camping</h3>
              </div>
              <div className="features-four-icon-two">
                <i className="icon-www1" />
              </div>
              <div className="features-four-detail-box">
                <p>Nemo enim volu ernatue conseue ratine atem</p>
              </div>
              <div className="features-four-btn">
                <Link to="/services-details">Read More</Link>
                <i className="icon-right-arrow" />
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
            <div
              className="features-four-box features-four-box-3 wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <div className="features-four-icon-one">
                <i className="icon-Line" />
              </div>
              <div className="features-four-title-box">
                <h3>Market Research</h3>
              </div>
              <div className="features-four-icon-two">
                <i className="icon-shuttle1" />
              </div>
              <div className="features-four-detail-box">
                <p>Will give you a complete account of the system</p>
              </div>
              <div className="features-four-btn">
                <Link to="/services-details">Read More</Link>
                <i className="icon-right-arrow" />
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
            <div
              className="features-four-box features-four-box-4 wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="features-four-icon-one">
                <i className="icon-Line" />
              </div>
              <div className="features-four-title-box">
                <h3>Competitive Analysis</h3>
              </div>
              <div className="features-four-icon-two">
                <i className="icon-analytics1" />
              </div>
              <div className="features-four-detail-box">
                <p>Expound actu teachings of the great explorer</p>
              </div>
              <div className="features-four-btn">
                <Link to="/services-details">Read More</Link>
                <i className="icon-right-arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeaturesFour
